import { createApiSlice } from "@common";
import {
  EXTERNAL_APP_INTEGRATION
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "createExternalAppIntegration",
    method: "post",
    url: `${EXTERNAL_APP_INTEGRATION}/generate`,
    stateKey: "message",
  },
  {
    name: "getExternalAppIntegration",
    method: "get",
    url: `${EXTERNAL_APP_INTEGRATION}`,
    stateKey: "data",
  },
  {
    name: "deleteExternalAppIntegration",
    method: "delete",
    url: `${EXTERNAL_APP_INTEGRATION}/revoke`,
    stateKey: "message",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    additionalData: [],
    data: [],
    selectedData: {},
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
    rowSelect: (state, action) => {
      state.selectedData = action?.payload.length > 0 && action?.payload[0];
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "externalAppIntegration",
  apiConfig,
  customReducers,
);
const externalAppIntegrationSlice = slice;
// Export the slice's reducer
export default externalAppIntegrationSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
  createExternalAppIntegration,
  getExternalAppIntegration,
  deleteExternalAppIntegration,
} = thunks;

// Destructure and export actions
export const { rowSelect } =
  actions;
